import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { match as MatchProps, Route, Switch } from "react-router";

import DentalLabOrderForm from "./DentalLabOrderForm";
import DentalLabOrderList from "./DentalLabOrderList";
import DentalLabOrderInfo from "./DentalLabOrderInfo";
import { Client } from "../../../interfaces/ClientInterface";
import { notificationAdd } from "../../../actions/notification";
import { getDentalLabOrders } from "../../../api/dentalLabOrder";
import { DentalLabOrder } from "../../../interfaces/DentalLabOrder";
import { DentalLabFormMode } from "../../../enum/DentalLabOrder";

const DentalLabOrders = ({ match }: { match: MatchProps }): React.JSX.Element => {
  const pageSize = 20;
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [selectedRow, setSelectedRow] = useState<Partial<DentalLabOrder> | null>(null);
  const [selectedClient, setSelectedClient] = useState<Partial<Client> | null>(null);
  const [dentalLabOrderData, setDentalLabOrderData] = useState<{
    results: DentalLabOrder[];
    total: number;
  } | null>({
    results: [],
    total: 0
  });

  const onClose = () => {
    setSelectedRow(null);
    dispatch(push(match.path));
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await getDentalLabOrders({
          page,
          pageSize,
          clientIds: selectedClient?.id ? [selectedClient.id] : []
        });
        setDentalLabOrderData(data);
      } catch (err) {
        dispatch(
          notificationAdd({
            id: new Date().getUTCMilliseconds(),
            variant: "error",
            message: "Failed to get dental lab orders",
            autoTimeout: true
          })
        );
      }
    })();
  }, [page, dispatch, selectedClient?.id]);

  return (
    <Box height="100%" pt={2}>
      <DentalLabOrderList
        page={page}
        setPage={setPage}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        dentalLabOrderData={dentalLabOrderData}
      />

      <Switch>
        <Route
          exact
          path={`${match.path}/create`}
          render={(props) => (
            <DentalLabOrderForm
              onClose={onClose}
              mode={DentalLabFormMode.CREATE}
              dentalLabOrderData={dentalLabOrderData}
              setDentalLabOrderData={setDentalLabOrderData}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          )}
        />

        <Route
          exact
          path={`${match.path}/:id`}
          render={(props) => (
            <DentalLabOrderInfo
              onClose={onClose}
              selectedRow={selectedRow}
              setDentalLabOrderData={setDentalLabOrderData}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          )}
        />

        <Route
          exact
          path={`${match.path}/:id/edit`}
          render={(props) => (
            <DentalLabOrderForm
              onClose={onClose}
              mode={DentalLabFormMode.EDIT}
              dentalLabOrder={selectedRow as DentalLabOrder}
              dentalLabOrderData={dentalLabOrderData}
              setDentalLabOrderData={setDentalLabOrderData}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          )}
        />
      </Switch>
    </Box>
  );
};

export default DentalLabOrders;
